export const GET_ENTITYPICKER_START = 'GET_ENTITYPICKER_START';
export const GET_ENTITYPICKER_PROCESS = 'GET_ENTITYPICKER_PROCESS';
export const GET_ENTITYPICKER_SUCCESS = 'GET_ENTITYPICKER_SUCCESS';
export const RESET_ENTITYPICKER_START = 'RESET_ENTITYPICKER_START';
